import { ColumnsType } from "antd/es/table";
import { Space, Dropdown } from "antd";
import ColumnSearch from "./ColumnSearch"; // Seu componente de busca
import { BotoesAcoes } from "../styles"; // Botões de ação
import SettingsIcon from "@mui/icons-material/Settings";

import { getMenuItems } from "../constants/itemsActionColumns";

export const Columns = (
  onClick: (e: any) => void,
  setReservaId: (id: number) => void,
  setNomeEmpreend: (nomeEmpreend: string) => void,
  setCheckIn: (setCheckIn: string) => void,
  setCheckOut: (setCheckOut: string) => void,
  setProprietarioId: (setProprietarioId: number) => void,
  setCotaUsuario: (setProprietarioId: number) => void
): ColumnsType<any> => {
  const items = getMenuItems(); // Gera os itens com base nas reservas
  return [
    {
      title: "Reserva id",
      dataIndex: "id",
      key: "id",
      width: "30%",
      ...ColumnSearch<any>({ dataIndex: "id" }),
    },
    {
      title: "Nome Empreendimento",
      dataIndex: "nomeEmpreendimento",
      key: "nomeEmpreendimento",
      width: "30%",
      ...ColumnSearch<any>({ dataIndex: "nomeEmpreendimento" }),
    },
    {
      title: "Status da reserva",
      dataIndex: "statusReserva",
      key: "statusReserva",
      width: "30%",
      ...ColumnSearch<any>({ dataIndex: "statusReserva" }),
    },
    {
      title: "Check-in",
      dataIndex: "checkIn",
      key: "checkIn",
      width: "30%",
      ...ColumnSearch<any>({ dataIndex: "checkIn" }),
    },
    {
      title: "Check-out",
      dataIndex: "checkOut",
      key: "checkOut",
      width: "30%",
      ...ColumnSearch<any>({ dataIndex: "checkOut" }),
    },
    {
      title: "Data Locação",
      dataIndex: "dataLocacao",
      key: "dataLocacao",
      width: "30%",
      ...ColumnSearch<any>({ dataIndex: "dataLocacao" }),
    },
    {
      title: "Canal",
      dataIndex: "canal",
      key: "canal",
      width: "30%",
      ...ColumnSearch<any>({ dataIndex: "canal" }),
    },
    {
      title: "Ações",
      dataIndex: "operation",
      key: "operation",
      width: "10%",
      align: "center",
      render: (item, row) => (
        <Space size="middle">
          <Dropdown menu={{ items, onClick }} trigger={["click"]}>
            <BotoesAcoes
              onClick={() => {
                setReservaId(row.id);
                setNomeEmpreend(row.nomeEmpreendimento);
                setCheckIn(row.checkIn);
                setCheckOut(row.checkOut);
                setProprietarioId(row.proprietarioId);
                setCotaUsuario(row.cotaUsuario);
              }}
            >
              <Space>
                <SettingsIcon />
              </Space>
            </BotoesAcoes>
          </Dropdown>
        </Space>
      ),
    },
  ];
};
